import React from "react";

const CDN = "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english";

const LOGOS = {
  html: `${CDN}/html-logo.avif`,
  css: `${CDN}/css-logo.avif`,
  javascript: `${CDN}/Java-script-logo.avif`,
  bootstrap: `${CDN}/bootstrap-logo.avif`,
  python: `${CDN}/python-logo.avif`,
  react: `${CDN}/react-logo.avif`,
  tailwind: `${CDN}/tailwind-logo.avif`,
  springBoot: `${CDN}/spring-boot-logo.avif`,
  java: `${CDN}/java-logo.avif`,
};

export const COURSE_LOGOS = {
  mernUp: [LOGOS.html, LOGOS.css, LOGOS.javascript, LOGOS.bootstrap],
  mernDown: [LOGOS.python, LOGOS.react, LOGOS.tailwind],
  javaDown: [LOGOS.springBoot, LOGOS.java, LOGOS.tailwind],
  mobileFull: [
    LOGOS.html,
    LOGOS.css,
    LOGOS.javascript,
    LOGOS.bootstrap,
    LOGOS.python,
    LOGOS.tailwind,
    LOGOS.react,
  ],
  mobileJava: [
    LOGOS.javascript,
    LOGOS.java,
    LOGOS.tailwind,
    LOGOS.springBoot,
    LOGOS.html,
    LOGOS.css,
    LOGOS.bootstrap,
  ],
};

function LogoStrip({ logos, items, labeled }) {
  if (labeled && items?.length) {
    const loopItems = [...items, ...items];
    return (
      <>
        {loopItems.map((item, index) => (
          <div
            key={`${item.id}-${index}`}
            className="course-logo-marquee__cell"
          >
            <img
              loading="lazy"
              src={item.src}
              alt=""
              className="course-logo-marquee__icon"
            />
            <span className="course-logo-marquee__label">{item.label}</span>
          </div>
        ))}
      </>
    );
  }

  const loopLogos = [...logos, ...logos];

  return (
    <>
      {loopLogos.map((src, index) => (
        <img
          key={`${src}-${index}`}
          loading="lazy"
          src={src}
          alt=""
          className="course-logo-marquee__img"
        />
      ))}
    </>
  );
}

/** Vertical infinite scroll – top row moves up, bottom row moves down */
export function VerticalCourseLogoMarquee({
  logos = [],
  items,
  labeled = false,
  direction = "up",
}) {
  return (
    <div className={`course-logo-marquee course-logo-marquee--vertical course-logo-marquee--${direction}${labeled ? " course-logo-marquee--labeled" : ""}`}>
      <div className="course-logo-marquee__track">
        <LogoStrip logos={logos} items={items} labeled={labeled} />
      </div>
    </div>
  );
}

/** Horizontal infinite scroll for mobile strips */
export function HorizontalCourseLogoMarquee({
  logos = [],
  items,
  labeled = false,
  direction = "left",
}) {
  return (
    <div className={`course-logo-marquee course-logo-marquee--horizontal course-logo-marquee--${direction}${labeled ? " course-logo-marquee--labeled" : ""}`}>
      <div className="course-logo-marquee__track">
        <LogoStrip logos={logos} items={items} labeled={labeled} />
      </div>
    </div>
  );
}
